/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — LinkedIn/ABM outreach. Real dashboard computed live from
   lemlist (campaigns + batch stats + inbox), synced via the Connectors page's
   "LinkedIn/ABM" button. Plus one admin-maintained field with no lemlist source:
   workflow category. "Request a Campaign" lives in growthosMarketingCampaignApiSlice
   — it's shared across every Marketing sub-page, not scoped to LinkedIn/ABM.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get, patchGeneric } from '../common/constants'

const LINKEDIN_ABM = apiConstants.GROWTHOS_ADMIN_LINKEDIN_ABM

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

// Drop undefined/empty params — `get` would otherwise send them as the literal "undefined".
const clean = (params) => Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))

export const growthosLinkedinAbmApiSlice = createApi({
  reducerPath: 'growthosLinkedinAbmApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['LinkedInAbm'],
  endpoints: (b) => ({
    getLinkedInAbm: b.query({
      queryFn: ({ period, from, to } = {}) => run(get(LINKEDIN_ABM, clean({ period, from, to }))),
      providesTags: ['LinkedInAbm'],
    }),
    updateLinkedInAbmWorkflow: b.mutation({
      queryFn: ({ campaignId, body }) => run(patchGeneric(`${LINKEDIN_ABM}/workflows/${campaignId}`, body)),
      invalidatesTags: ['LinkedInAbm'],
    }),
  }),
})

export const {
  useGetLinkedInAbmQuery,
  useUpdateLinkedInAbmWorkflowMutation,
} = growthosLinkedinAbmApiSlice
